<template>
  <div class="chat_box" @click="bodyClick">
    <div class="chat">
      <div class="chat-top">
        <h3 class="chat_title flex-auto">蓝韵心理咨询服务平台咨询服务</h3>
        <div class="login_out" @click="loginout()">
          <span style="color:#111">{{curUserInfo.DISPLAY_NAME}}</span>
          <i class="iconfont icon-tuichu"></i> 退出
        </div>
      </div>

      <el-container>
        <el-aside width="300px">
          <div class="chat_warp">
            <ul
              class="chat_list"
              v-infinite-scroll="loadChatList"
              infinite-scroll-disabled="disabledChatLoad"
            >
              <li
                class="chat_item"
                :class="{
                  active_chat: currentChat.DEST_USER_ID == item.DEST_USER_ID,
                }"
                v-for="(item, index) in chatList"
                :key="index"
                @click="chatItemClick(item)"
              >
                <el-image
                  class="head_portrait"
                  fit="cover"
                  :src="
                    item.AVATAR
                      ? $imgUrl + item.AVATAR
                      : '/static/images/default.png'
                  "
                ></el-image>
                <div class="chat_content">
                  <div class="content_top">
                    <div class="chat_name">
                      {{ item.DISPLAY_NAME }}
                    </div>
                    <div class="chat_date">
                      {{
                        $LYUtils.momentTime(
                          item.UPDATE_TIME
                            ? item.UPDATE_TIME
                            : item.CREATE_TIME,
                          "YYYY/MM/DD HH:mm"
                        )
                      }}
                    </div>
                  </div>
                  <div class="last_msg">
                    {{ $LYUtils.entitiestoUtf16(item.LAST_MSG) }}
                  </div>
                </div>
              </li>
            </ul>
            <p class="loading_chat" v-if="noMoreChat">没有更多了</p>
            <!-- <p class="loading_chat" v-if="loadingChatList">加载中...</p> -->
          </div>
        </el-aside>
        <el-container v-if="chatList.length > 0">
          <el-header height="50px">
            <div class="head_warp">
              <div class="name">{{ currentChat.DISPLAY_NAME }}</div>

              <countDown
                v-if="duration && isStartService"
                :remainTime="duration"
                @countTimeEnd="countTimeEnd"
              />
              <div class="end_service" v-if="isStartService">
                <img src="/static/images/end.png" alt="" />
                <span @click="endService">结束服务</span>
              </div>
            </div>
          </el-header>
          <!-- 消息列表 -->
          <el-main>
            <ul class="msg_warp" ref="msgListRef" @scroll="msgScroll">
              <div class="loading" v-show="isLoadingMsg">加载中...</div>
              <!-- <div class="loading" v-show="isLoadMsgMore">没有更多了</div> -->
              <li
                v-for="(item, index) in msgList"
                :key="index"
                :id="'msg' + item.CHAT_ID"
              >
                <div class="system" v-if="getHistoryTime(item, index)">
                  <span class="system_date">{{
                    getHistoryTime(item, index)
                  }}</span>
                </div>
                <!-- 系统消息 -->
                <div
                  class="system"
                  v-if="item.MESSAGE_TYPE == 4 && item.DATA_TYPE == 1"
                >
                  <span class="system_date">{{ item.MESSAGE }}</span>
                </div>
                <div
                  v-else
                  class="msg_item"
                  :class="{
                    msg_right: item.SPEAKER_ID == loginInfo.USER_ID,
                    msg_left: item.SPEAKER_ID != loginInfo.USER_ID,
                  }"
                >
                  <!-- 自己头像 -->
                  <el-image
                    class="msg_portrait"
                    fit="cover"
                    :src="
                      loginInfo.AVATAR
                        ? $imgUrl + loginInfo.AVATAR
                        : '/static/images/consult.png'
                    "
                    v-if="item.SPEAKER_ID == loginInfo.USER_ID"
                  >
                    <div slot="error" class="image-slot">
                      <el-image
                        class="msg_portrait"
                        fit="cover"
                        src="/static/images/consult.png"
                      ></el-image>
                    </div>
                  </el-image>
                  <!-- 用户头像 -->
                  <el-image
                    class="msg_portrait"
                    fit="cover"
                    :src="
                      currentChat.AVATAR
                        ? $imgUrl + currentChat.AVATAR
                        : '/static/images/default.png'
                    "
                    v-else
                  ></el-image>
                  <!-- 文字信息 -->
                  <div class="msg_content" v-if="item.DATA_TYPE == 1">
                    {{ $LYUtils.entitiestoUtf16(item.MESSAGE) }}
                  </div>
                  <!-- 图片信息 -->
                  <div
                    class="msg_content img_content"
                    v-if="item.DATA_TYPE == 2"
                  >
                    <el-image
                      fit="cover"
                      :src="
                        item.EX1
                          ? $chatFilUrl + item.EX1
                          : $chatFilUrl + item.DATA
                      "
                      :preview-src-list="[$chatFilUrl + item.DATA]"
                    ></el-image>
                  </div>

                  <!-- 语音信息 -->
                  <div
                    :style="{ width: `${50 + item.DURATION * 2}px` }"
                    class="msg_content voice_content"
                    :class="{
                      voice_content_right: item.SPEAKER_ID != loginInfo.USER_ID,
                    }"
                    @click="playAudio(item)"
                    v-if="item.DATA_TYPE == 3"
                  >
                    <div
                      class="voice_icon"
                      :class="[
                        {
                          voice_icon_right:
                            item.SPEAKER_ID == loginInfo.USER_ID,
                        },
                        {
                          voice_icon_left: item.SPEAKER_ID != loginInfo.USER_ID,
                        },
                        {
                          voice_icon_right_an:
                            isAudioStart &&
                            item.SPEAKER_ID == loginInfo.USER_ID,
                        },
                        {
                          voice_icon_left_an:
                            isAudioStart &&
                            item.SPEAKER_ID != loginInfo.USER_ID,
                        },
                      ]"
                    ></div>
                    <div>{{ item.DURATION }}''</div>
                  </div>
                </div>
              </li>
            </ul>
          </el-main>
          <!-- 功能区 -->
          <el-footer height="190px">
            <div class="toolbar">
              <div class="tool_left">
                <div class="emoji" v-show="isEmoji">
                  <div class="emoji_list">
                    <div
                      @click="chooseEmoji(item)"
                      class="emoji_item"
                      v-for="item in emojiList"
                      :key="item"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
                <i @click.stop="emojiFn" class="iconfont icon-biaoqing-"></i>
                <i
                  @click="tigeerImg()"
                  class="iconfont el-icon-picture-outline"
                ></i>
                <!-- <i class="iconfont icon-jietu"></i> -->
                <!-- <i class="iconfont icon-luyin"></i> -->
                <form class="filehide" id="lyform">
                  <input
                    type="file"
                    name="imfile"
                    id="imgfile"
                    @change="imgChange"
                    accept=".jpg,.jpeg,.png,.gif"
                    enctype="multipart/form-data"
                  />
                </form>
              </div>
              <div class="tool_right"></div>
            </div>
            <el-input
              type="textarea"
              class="msg_text"
              border="0"
              clearable
              resize="none"
              :rows="2"
              placeholder="请输入内容"
              v-model="msgText"
            >
            </el-input>
            <div class="btn_bar">
              <span class="send_btn" @click="sendMsg(1)">发送(s)</span>
            </div>
          </el-footer>
        </el-container>
        <div v-else class="no_date">
          <div>
            <div><i class="icon el-icon-chat-dot-round"></i></div>
            <div class="text">暂无咨询服务</div>
          </div>
        </div>
      </el-container>
    </div>
    <audio id="audio" style="display: none" controls @ended="audioPlayEnd">
      <source :src="autioSrc" type="audio/mpeg" />
      您的浏览器不支持该音频格式。
    </audio>
    <el-dialog
      title="服务提示"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="serviceDialog"
      width="700px"
    >
      <span>您有新的咨询服务，请点击开始</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="startService">开 始</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import emojiList from "../../../static/js/emoji";
import countDown from "@/components/countDown";
export default {
  data() {
    return {
      isStartService: false, // 开始服务
      isEndservice: false, // 结束服务
      serviceDialog: false,
      serviceObj: {}, // 服务提示信息
      // 音频地址
      autioSrc: "",
      isAudioStart: false, // 音频是否开始
      socket: "",
      noticeSocket: "",
      msgText: "",
      chatList: [],
      newChatList: [],
      msgList: [],
      newMsgList: [],
      emojiList: [],
      isEmoji: false,
      msgHeight: 300,
      loadingChatList: false,
      // 聊天列表分页信息
      chatPageInfo: {
        CurrPageNo: 1,
        PageDataNum: 15,
        AllDataNum: 0,
      },
      // 消息列表分页
      msgPageInfo: {
        CurrPageNo: 1,
        PageDataNum: 15,
        AllDataNum: 0,
      },
      crollHeigh: 0,
      loginInfo: null,
      currentChat: {},
      curUserInfo: {},
      duration: 0, // 服务倒计时
      userInfo: null, // 用户信息
      imgUrl: "", // 图片地址
      serviceInfo: null, //开始服务时的服务信息、
      oldScrollHeight: 0,
      isend: true,
      isLoadingMsg: false,
      isLoadMsgMore: false,
      isNotification: false,
    };
  },
  components: {
    countDown,
  },
  created() {
    let userInfo = window.sessionStorage.getItem("userInfo");
    if (userInfo) {
      this.curUserInfo = JSON.parse(userInfo);
 
    }

    this.getChatList(); // 获取聊天列表
    this.loginInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    // 是否有正在开启的服务
    this.serviceInfo = JSON.parse(window.localStorage.getItem("serviceInfo"));
    if (this.serviceInfo) {
      // 服务时长
      let serviceTime =
        (new Date() - new Date(this.serviceInfo.START_TIME)) / 60000; // 转分钟单位
      // 服务时长已过
      console.log(serviceTime * 60);
      if (serviceTime >= this.serviceInfo.DURATEION) {
        this.isEndservice = true;
        this.isStartService = false;
      } else {
        this.isStartService = true;
        this.isEndservice = false;
        this.duration = (this.serviceInfo.DURATEION - serviceTime) * 60; // 时长 （秒）
      }
      // this.isStartService = true;
      // this.isEndservice = false;
      // this.serviceInfo = res.data; //
      // this.duration = res.data.DURATEION * 60; // 时长 （秒）
      // var newChat = null;
    }
  },
  mounted() {
    this.emojiList = emojiList;
    // 初始化聊天推送
    this.initWebSocket();
    this.initNoticeSocket();
    this.$nextTick(() => {
      let audio = document.getElementById("audio");
      audio.load();
    });
    this.suportNotify();
  },
  computed: {
    noMoreChat() {
      return (
        this.chatList.length ==
        this.chatPageInfo.AllDataNum + this.newChatList.length
      );
    },
    disabledChatLoad() {
      return this.loadingChatList || this.noMoreChat;
    },
  },
  methods: {
    //浏览器消息提示是否支持
    suportNotify() {
      if (window.Notification) {
        this.isNotification = true;
      } else {
        this.$notify("不支持 Web Notifications API");
      }
    },
    // 唤起浏览器弹框 前提浏览器得允许弹框通知显示
    showMess(userInfo) {
 
      if (this.isNotification && document.hidden) {
        var that = this;
        //如果支持window.Notification 并且 许可不是拒绝状态
        if (window.Notification && Notification.permission !== "denied") {
          //Notification.requestPermission这是一个静态方法，作用就是让浏览器出现是否允许通知的提示
          Notification.requestPermission(function (status) {
            //如果状态是同意
            if (status === "granted") {
              var m = new Notification("您有新的咨询消息，请点击查看", {
                body:
                  that.chatList.find(
                    (item) => item.DEST_USER_ID == userInfo.SPEAKER_ID
                  ).DISPLAY_NAME +
                  "说：" +
                  userInfo.MESSAGE, //消息体内容
                icon: "/static/images/logo_icon.png", //消息图片
              });

              //点击当前消息内容
              (m.onclick = function () {
                //点击当前消息提示框后，跳转到当前页面
                that.$router.push({ path: "/psychiatristChat" });
                window.focus();
              }),
                //点击关闭消息提示框
                (m.onclose = function () {
                  m.close();
                });
            }
          });
        }
      }
    },

    // 消息记录滚动条监听
    msgScroll(e) {
      //滚动的像素+容器的高度>可滚动的总高度-100像素
      if (e.srcElement.scrollTop < 40) {
        if (this.isLoadingMsg || this.isLoadMsgMore) {
          return;
        }
        this.msgPageInfo.CurrPageNo++;

        this.oldScrollHeight = e.srcElement.scrollHeight; // 加载更多记录前滚动区域的高度

        this.getMsgList();
      }
    },
    // 历史记录时间展示
    getHistoryTime(row, index) {
      let lastRow = null;
      if (this.msgList.length > 0 && index > 0) {
        lastRow = this.msgList[index - 1]; // 上一条记录
      }
      if (lastRow) {
        let oDate = new Date(row.CREATE_TIME) - new Date(lastRow.CREATE_TIME); // 时间差
        if (oDate > 180000) {
          // 180000 差距3分钟
          return this.$LYUtils.momentTime(
            row.CREATE_TIME,
            "YYYY年MM月DD HH:mm"
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    // 退出登录
    loginout() {
      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios.post(`sysSvr/User/SignOut`, {}).then((res) => {
            if (res.code == 0 || res.code == 20) {
              window.sessionStorage.removeItem("token");
              location.reload();
            }
          });
        })
        .catch(() => {});
    },
    // 倒计时结束
    countTimeEnd() {
      this.isEndservice = true;
    },
    // 获取聊天列表
    getChatList(loadMore) {
      this.$axios
        .post(`MsgApiSvr/Chat/GetChatRecordList`, {
          PageInfo: this.chatPageInfo,
          queryIterms: null,
        })
        .then((res) => {
          if (res.code == 0 || res.code == 200) {
            if (res.data && res.data.Datas) {
              this.chatList = this.chatList.concat(res.data.Datas);
              this.chatPageInfo = res.data.PageInfo;
              // 是否为加载更多数据
              if (loadMore) {
                this.loadingChatList = false;
              } else {
                this.currentChat = this.chatList[0]; // 默认选中第0个聊天对象
                this.getMsgList(true); // 获取聊天记录信息
              }
            }
          }
        });
    },
    // 切换聊天列表
    chatItemClick(item) {
      if (this.isStartService) {
        return this.$message.info("请先完成本次服务！");
      }
      this.msgList = [];
      this.msgPageInfo = {
        CurrPageNo: 1,
        PageDataNum: 10,
        AllDataNum: 0,
      };
      this.currentChat = item;
      this.getMsgList(true);
    },
    // 获取聊天记录列表
    getMsgList(isfirst) {
      this.isLoadingMsg = true;
      this.$axios
        .post(`MsgApiSvr/Chat/GetChatInfoList`, {
          PageInfo: this.msgPageInfo,
          destUserId: this.currentChat.DEST_USER_ID,
        })
        .then((res) => {
          if (res.data && res.data.Datas && res.data.Datas.length > 0) {
            this.msgPageInfo = res.data.PageInfo;
            this.msgList = [...res.data.Datas, ...this.msgList];
            console.log(this.msgList.length);
            console.log(this.newMsgList.length);
            console.log(this.msgPageInfo.AllDataNum);
            if (
              this.msgList.length >=
              this.msgPageInfo.AllDataNum + this.newMsgList.length
            ) {
              this.isLoadMsgMore = true;
            }
            this.isLoadingMsg = false;

            if (isfirst) {
              // 首次加载滚动到聊天底部
              this.$nextTick(() => {
                setTimeout(() => {
                  this.backBottom();
                }, 20);
              });
            } else {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.$refs.msgListRef.scrollTop =
                    this.$refs.msgListRef.scrollHeight - this.oldScrollHeight;
                }, 20);
              });
            }
          } else {
            this.isLoadingMsg = false;
          }
        });
    },
    // 播放音频
    playAudio(item) {
      let audio = document.getElementById("audio");
      if (this.isAudioStart) {
        audio.pause();
        this.isAudioStart = false;
      } else {
        this.autioSrc = this.$chatFilUrl + item.DATA;
        audio.load();
        this.$nextTick(() => {
          audio.play();
        });
        this.isAudioStart = true;
      }
    },
    // 播放结束
    audioPlayEnd() {
      this.isAudioStart = false;
    },
    // 选择表情
    chooseEmoji(item) {
      this.msgText += item;
    },
    bodyClick() {
      this.isEmoji = false;
    },
    // 表情包
    emojiFn() {
      this.isEmoji = true;
    },
    //点击选择图片
    tigeerImg() {
      $("#imgfile").val("");

      let fileValue = $("#imgfile").val();
      console.log(fileValue);
      $("#imgfile").trigger("click");
    },
    imgChange(e) {
      let self = this;
      let formData = new FormData($("#lyform")[0]);
      $.ajax({
        url: this.$chatFilUrl + "JsonSvc/ChatController.UploadChatFile",
        type: "POST",
        async: false,
        data: formData,
        processData: false,
        dataType: "json",
        success: function (data, textStatus, jqXHR) {
          console.log(data);
          self.sendMsg(2, data); // 发送图片信息
        },
        error: function (ex) {
          self.$message.error("发送图片失败");
        },
      });
    },
    // 滚动到聊天消息底部
    backBottom() {
      // 参考资料 https://blog.csdn.net/qq449736038/article/details/80769507
      this.$nextTick(() => {
        this.$refs.msgListRef.scrollTop = this.$refs.msgListRef.scrollHeight;
      });
    },
    loadChatList() {
      this.loadingChatList = true;
      this.chatPageInfo.CurrPageNo++;
      this.getChatList(true);
    },
    // 初始化聊天推送链接
    initWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.$chatUrl);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getChatMessage;
      }
    },
    // 初始化消息推送链接
    initNoticeSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.noticeSocket = new WebSocket(this.$noticeUrl);
        // 监听socket连接
        this.noticeSocket.onopen = this.noticeOpen;
        // 监听socket错误信息
        this.noticeSocket.onerror = this.noticeError;
        // 监听socket消息
        this.noticeSocket.onmessage = this.getNoticeMessage;
      }
    },
    // 连接成功
    open: function () {
      let tmp = {
        MESSAGE_TYPE: 1,
        Token: this.loginInfo.Token,
      };
      this.socket.send(JSON.stringify(tmp));
    },
    noticeOpen: function () {
      this.noticeSocket.send(this.loginInfo.Token);
    },
    // 连接错误
    error: function () {
      
    },
    noticeError: function () {
 
    },
    // 接收信息
    getChatMessage: function (res) {
  
      if (res && res.data) {
        let chatData = JSON.parse(res.data);
        console.log(chatData)
        if (chatData.State) {
          let date = chatData.Value;

         
          if (chatData.Tag == 1) {
            //Tag:1.聊天信息列表  2.聊天记录列表
            let newChat = null;

            this.chatList.forEach((item, index) => {
              if (item.DEST_USER_ID == date.DEST_USER_ID) {
                this.chatList.splice(index, 1);

                newChat = item;
              }
            });
            this.chatList.unshift(date);
            if (!newChat) {
              this.newChatList.unshift(date);
            }
          } else if (chatData.Tag == 2) {
            // 判断是否为当前聊天对象
            if (
              this.currentChat.DEST_USER_ID == date.DEST_USER_ID ||
              this.currentChat.DEST_USER_ID == date.SPEAKER_ID
            ) {
              this.msgList.push(date);
              this.newMsgList.push(date);
            }
          }
          this.backBottom();
          console.log(date);
          this.showMess(date);
        }
      }
    },
    getNoticeMessage(res) {
      debugger
      if (res.data) {
        this.serviceObj = JSON.parse(res.data);
        this.serviceDialog = true;
        this.geUserInfoByUserId(); // 获取用户信息
      }
    },
    geUserInfoByUserId() {
      this.$axios
        .post(`sysSvr/User/GetUserInfoById2`, {
          userId: JSON.parse(this.serviceObj.Ex1).UserId,
        })
        .then((res) => {
          if (res.code == 200 || res.code == 0) {
            this.userInfo = res.data;
            this.showMess(this.userInfo);
          }
        });
    },
    // 开启服务
    startService() {
      if (this.serviceObj && this.serviceObj.Ex1) {
        this.$axios
          .post(`counselingApiSvr/Counseling/StartWork`, {
            workId: JSON.parse(this.serviceObj.Ex1).WorkId,
          })
          .then((res) => {
            if (res.code == 0 || res.code == 200) {
              // 存储服务信息
              window.localStorage.setItem(
                "serviceInfo",
                JSON.stringify(res.data)
              );
              if (res.data && res.data.DURATEION) {
                this.isStartService = true;
                this.isEndservice = false;
                this.isend = false;
                this.serviceInfo = res.data; //
                this.duration = res.data.DURATEION * 60; // 时长 （秒）
                var newChat = null;
                this.chatList.forEach((item, index) => {
                  if (item.DEST_USER_ID == this.userInfo.USER_ID) {
                    newChat = item;
                    this.chatList.splice(index, 1);
                  }
                });
                if (!newChat) {
                  newChat = {
                    AVATAR: this.userInfo.AVATAR, // 头像
                    DISPLAY_NAME: this.userInfo.DISPLAY_NAME, // 名字
                    DEST_USER_ID: this.userInfo.USER_ID, // 聊天对象用户id
                    UPDATE_TIME: new Date(),
                  };
                  this.newChatList.unshift(newChat);
                }
                this.chatList.unshift(newChat);
                console.log(this.chatList);
                this.currentChat = newChat; // 默认选中第一个咨询用户
                this.sendMsg(1, {
                  type: 4,
                  statusText: "本次服务已开启",
                });
                this.msgList = [];
                this.getMsgList(true); //
              }
            }
          });
        // .catch((err) => {
        //   this.$message.error("开启咨询服务失败！");
        // });
        this.serviceDialog = false;
      }
    },
    // 结束服务
    endService() {
      let self = this;
      this.$confirm("确认结束本次服务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`counselingApiSvr/Counseling/StopWork`, {
              taskInfo: { TASK_ID: this.serviceInfo.TASK_ID },
            })
            .then((res) => {
              if (res.data) {
                window.localStorage.removeItem("serviceInfo");
                self.isend = true;
                self.isStartService = false;
                self.isEndservice = false;
                self.sendMsg(1, {
                  type: 4,
                  statusText: "本次服务已结束",
                });
                this.chatList[0].LAST_MSG = "本次服务已结束";
              }
            });
        })
        .catch((err) => {});
    },
    // 发送信息
    sendMsg: function (type, data) {
      let params = {
        MESSAGE_TYPE: 2, // 4.系统消息
        Token: this.loginInfo.Token,
        DATA_TYPE: type,
        AUDIENCE_ID: this.currentChat.DEST_USER_ID,
        CHAT_ID: this.$LYUtils.guid(),
      };
      // 系统消息
      if (type == 1 && data) {
        params.MESSAGE_TYPE = data.type;
      }
      if (type == 1) {
        if (data) {
          params.MESSAGE = data.statusText;
        } else {
          if (!this.msgText) return;
          params.MESSAGE = this.$LYUtils.utf16toEntities(this.msgText);
        }
      } else if (type == 2) {
        params.DATA = data[0]; //高清地址
        params.EX1 = data[1]; // 图片模糊地址
      }
      console.log(params);

      this.socket.send(JSON.stringify(params));
      params.SPEAKER_ID = this.loginInfo.USER_ID;
      this.msgList.push(params);
      this.newMsgList.push(params);
      // 更新已存在的聊天列表并重新置顶
      var newChat = null;
      this.chatList.forEach((item, index) => {
        if (item.DEST_USER_ID == this.currentChat.DEST_USER_ID) {
          newChat = item;
          this.chatList.splice(index, 1);
        }
      });
      if (newChat) {
        newChat.LAST_MSG = this.msgText;
        if (type == 2) {
          newChat.LAST_MSG = "[图片]";
        }
        if (type == 1 && data) {
          newChat.LAST_MSG = data.statusText;
        }
        newChat.UPDATE_TIME = new Date();
        this.chatList.unshift(newChat);
      }
      this.msgText = "";
      setTimeout(() => {
        this.backBottom();
      }, 200);
    },

    // 关闭链接
    close: function () {
      console.log("socket已经关闭");
    },
  },
  // destroyed() {
  //   // 销毁监听
  //   this.socket.onclose = this.close;
  // },
};
</script>

<style scoped lang="less">
.chat_box {
  height: 100%;
  width: 100%;
  background: linear-gradient(#648880, #293f50);
  background-size: cover;
}
.chat {
  overflow: hidden;
  width: 60%;
  height: 80vh;
  min-width: 900px;
  min-height: 500px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  .chat-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .flex-auto {
      flex: 1;
    }
  }
  .chat_title {
    text-align: center;
    color: #aaa;
    line-height: 50px;
  }
  .login_out {
    float: right;
    color: #aaa;
    cursor: pointer;
  }
  .no_date {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 75vh;
    color: #dedede;
    text-align: center;
    background: rgba(245, 245, 245, 1);

    .icon {
      font-size: 60px;
    }
    .text {
      font-size: 24px;
    }
  }
  .el-aside {
    height: 80vh;
    background: #eceae8;
    .chat_warp {
      height: 92%;
      overflow-y: auto;
      background: #eceae8;
      .chat_list {
        box-sizing: border-box;
        .chat_item {
          cursor: pointer;
          padding: 10px;
          display: flex;
          .head_portrait {
            width: 45px;
            height: 40px;
            border-radius: 5px;
          }
          .chat_content {
            margin-left: 10px;
            box-sizing: border-box;
            width: 100%;
            .content_top {
              display: flex;
              justify-content: space-between;
              .chat_name {
                font-size: 15px;
                font-style: normal;
                color: #000;
              }
              .chat_date {
                font-size: 10px;
                color: #7d7d7d;
              }
            }

            .last_msg {
              margin-top: 5px;
              font-size: 13px;
              color: #7d7d7d;
              width: 150px;
              overflow: hidden;
              text-overflow: ellipsis; //文本溢出显示省略号
              white-space: nowrap; //文本不会换行
            }
          }
        }
        .chat_item:hover {
          background: rgba(221, 219, 218);
        }
        .active_chat,
        .active_chat:hover {
          background: rgba(196, 196, 196);
        }
      }
      .loading_chat {
        text-align: center;
        font-size: 14px;
        color: #5e6d82;
        line-height: 1.5em;
      }
    }
  }
  .el-header {
    background: rgba(245, 245, 245, 1);
    border-bottom: 1px solid #e4e4e4;
    .head_warp {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #000;
      font-size: 16px;
      .end_service {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
        color: #e0706f;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .name {
        font-size: 18px;
      }
    }
  }
  .el-main {
    .loading {
      text-align: center;
      color: #aaa;
    }
    background: #f2f2f2;
    padding: 0 !important;
    .msg_warp {
      padding: 20px;
      height: calc(80vh - 280px);
      overflow: auto;
    }

    .system {
      margin: 10px 0;
      text-align: center;
      .system_date {
        padding: 2px 5px;
        background: rgba(218, 218, 218, 1);
        color: #fff;
        font-size: 10px;
        border-radius: 5px;
      }
    }

    .msg_item {
      margin: 10px 0;
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      .msg_portrait {
        width: 40px;
        height: 40px;
        border-radius: 5px;
      }
      // 文字消息内容
      .msg_content {
        position: relative;
        padding: 10px;
        max-width: 55%;
        border-radius: 5px;
        font-size: 14px;
      }
    }
    .msg_left {
      .msg_content {
        background-color: #fff;
        margin-left: 10px;
      }
    }
    .msg_left .msg_content::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 8px solid #fff;
      position: absolute;
      left: -7px;
      top: 15px;
    }
    .msg_right {
      flex-direction: row-reverse;
      .msg_content {
        background-color: #4cd964;
        margin-right: 10px;
      }
    }
    .msg_right .msg_content::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 8px solid #4cd964;
      position: absolute;
      right: -7px;
      top: 15px;
    }
    // 图片消息内容
    .img_content {
      padding: 0 !important;
      background: none !important;
      max-width: 60%;
      .el-image {
        border-radius: 5px;
      }
    }
    .img_content::after {
      border: none !important;
      display: none !important;
    }
    // 语音消息内容
    .voice_content {
      display: flex;
      flex-direction: row;
      align-items: center;
      max-width: 100px !important;
      .voice_icon {
        height: 20px;
        width: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
      }

      .voice_icon_right {
        background-image: url(/static/images/voice-left-3.png);
        margin-left: 10px;
      }

      .voice_icon_left {
        background-image: url(/static/images/voice-right-3.png);
        margin-right: 10px;
      }

      .voice_icon_right_an {
        animation: voiceAn_right 1s linear alternate infinite;
      }

      .voice_icon_left_an {
        animation: voiceAn_left 1s linear alternate infinite;
      }

      @keyframes voiceAn_right {
        0% {
          background-image: url(/static/images/voice-left-1.png);
        }

        50% {
          background-image: url(/static/images/voice-left-2.png);
        }

        100% {
          background-image: url(/static/images/voice-left-3.png);
        }
      }

      @keyframes voiceAn_left {
        0% {
          background-image: url(/static/images/voice-right-1.png);
        }

        50% {
          background-image: url(/static/images/voice-right-2.png);
        }

        100% {
          background-image: url(/static/images/voice-right-3.png);
        }
      }
    }
    .voice_content_right {
      flex-direction: row-reverse;
    }
    #lastMsg {
      height: 10px;
      width: 100%;
    }
  }
  .el-footer {
    padding: 0;
    background: #fff;
    .toolbar {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .tool_left {
        position: relative;
        .filehide {
          display: none;
        }
        .emoji {
          padding: 10px;
          box-sizing: border-box;
          position: absolute;
          left: -100px;
          top: -405px;
          width: 640px;
          height: 400px;
          margin: 0 auto;
          z-index: 999;
          background: rgba(255, 255, 255, 1);
          box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);

          .emoji_list {
            width: 100%;
            height: 380px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            overflow: auto;
            .emoji_item {
              width: 40px;
              height: 40px;
              font-size: 20px;
              cursor: pointer;
            }
          }
        }
      }
      .iconfont {
        color: #aaa;
        margin-left: 10px;
        cursor: pointer;
      }
      .icon-biaoqing- {
        font-size: 23px;
      }
      .icon-luyin {
        font-size: 24px;
      }

      .icon-jietu {
        font-size: 30px;
      }
      .el-icon-picture-outline {
        font-size: 24px;
      }
    }
    .el-textarea__inner {
      border: none !important;
    }
    .btn_bar {
      display: flex;
      justify-content: flex-end;
      .send_btn {
        margin: 5px 20px 10px 0;
        padding: 4px 15px;
        background: #f5f5f5;
        font-size: 14px;
        color: #aaa;
        cursor: pointer;
        border: 1px solid #dcdcdc;
      }
      .send_btn:hover {
        color: #fff;
        border: 1px solid #129611;
        background: #129611;
      }
    }
  }
}
</style>
<style>
.chat .el-textarea__inner {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/psychiatristChat/psychiatristChat.vue